import { render, staticRenderFns } from "./ResultingPrespostAudit.vue?vue&type=template&id=0980bceb"
import script from "./ResultingPrespostAudit.vue?vue&type=script&lang=js"
export * from "./ResultingPrespostAudit.vue?vue&type=script&lang=js"
import style0 from "./ResultingPrespostAudit.vue?vue&type=style&index=0&id=0980bceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports